import React from 'react'

const BookingSkeleton = () => (
  <div className="flex flex-col items-center justify-center min-h-[200px] animate-pulse bg-gray-100 rounded-lg p-6">
    <div className="w-16 h-16 bg-gray-300 rounded-full mb-4" />
    <div className="w-40 h-4 bg-gray-300 rounded mb-2" />
    <div className="w-32 h-4 bg-gray-200 rounded mb-2" />
    <div className="w-24 h-4 bg-gray-200 rounded" />
  </div>
)

export default BookingSkeleton
